import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { Routing } from "@/pages/routing";
import VHeader from "@/widgets/header";
import VFooter from "@/widgets/footer/ui/VFooter.vue";
import {ref, inject, onMounted} from "vue";
import SidebarMenu from "@/shared/ui/sidebar-menu/ui/SidebarMenu.vue";
import { AnalyticsInstance } from 'analytics';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const analytics = inject<AnalyticsInstance>('analytics');


const isSidebarOpen = ref(false);

onMounted(() => {
  analytics?.page();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(VHeader), {
      isSidebarOpen: isSidebarOpen.value,
      "onUpdate:isSidebarOpen": _cache[0] || (_cache[0] = ($event: any) => ((isSidebarOpen).value = $event))
    }, null, 8, ["isSidebarOpen"]),
    (isSidebarOpen.value)
      ? (_openBlock(), _createBlock(SidebarMenu, {
          key: 0,
          isSidebarOpen: isSidebarOpen.value,
          "onUpdate:isSidebarOpen": _cache[1] || (_cache[1] = ($event: any) => ((isSidebarOpen).value = $event))
        }, null, 8, ["isSidebarOpen"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Routing)),
    _createVNode(VFooter)
  ]))
}
}

})